import {
  Button,
  Grid,
  Pagination,
  PaginationItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";
import { GetSaleItemsResponse } from "../../../models/cartable.model";
import { ColumnModel, PageInfoModel } from "../../../models/common.model";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import { createStyles, makeStyles } from "@material-ui/core";
import createCache from "@emotion/cache";
import { CacheProvider, ThemeProvider } from "@emotion/react";
import { createTheme } from "@mui/material/styles";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import EmojiObjectsOutlinedIcon from "@mui/icons-material/EmojiObjectsOutlined";
import MaterialTextFieldComponent from "../../../components/textField/MaterialTextFieldCmp";
import ChipCmp from "../../../components/chip/chipCmp";
import { set } from "lodash";

const useStyles = makeStyles(() =>
  createStyles({
    select: {
      "&.Mui-selected": {
        backgroundColor: "#CEE5D3 !important",
      },
    },
  })
);
const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});
const nextIcon = () => {
  return (
    <img
      style={{ height: "12px", width: "10px" }}
      src="images/Next.png"
      alt=""
    />
  );
};
const previusIcon = () => {
  return (
    <img
      style={{ height: "12px", width: "10px" }}
      src="images/Previous.png"
      alt=""
    />
  );
};

const columns: readonly ColumnModel[] = [
  { id: "storeTitle", label: "فروشنده / شعبه" },
  { id: "customerFullName", label: "متقاضی" },
  { id: "customerNationalCode", label: "کد ملی" },
  { id: "customerMobileNumber", label: "شماره موبایل" },
  { id: "saleDatePersian", label: "تاریخ فروش" },
  { id: "factorNumber", label: "شماره فاکتور" },
  {
    id: "totalAmount",
    label: "مبلغ کل (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value.toLocaleString("fa");
    },
  },
];

interface Props {
  saleItems: GetSaleItemsResponse[];
  paginationInfo: PageInfoModel;
  setCurrentPaginationInfo: (page: any) => void;
  currentPaginationInfo: any;
  setFilter: (filter: any) => void;
  filter: { customerNationalCode: string };
  handleClickRow: (row: GetSaleItemsResponse) => void;
}

const SaleSettlementList = ({
  saleItems,
  currentPaginationInfo,
  paginationInfo,
  setCurrentPaginationInfo,
  setFilter,
  filter,
  handleClickRow,
}: Props) => {
  const classes = useStyles();
  const [selectedRow, setSelectedRow] = useState(undefined);
  const [formData, setFormData] = useState<{ customerNationalCode: string }>();

  const changePageNumber = (newPageNumber: number) => {
    setCurrentPaginationInfo({
      pageNumber: newPageNumber,
      pageSize: 10,
    });
  };
  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);
    // handleSelectRow(undefined);
  };
  function changeValueCustomerNationalCode(e: any) {
    // queryClient.setQueryData<string>(NATIONAL, e.currentTarget.value);
    setFormData({ customerNationalCode: e.currentTarget.value });
  }

  const handleFormSubmit = () => {
    setFilter(formData);
  };

  const setChildcustomerNationalCode = () => {
    setFormData({ ...formData, customerNationalCode: "" });
    setFilter({ ...filter, customerNationalCode: "" });
  };

  const deleteChip = () => {
    setFormData({ customerNationalCode: "" });
    setFilter({ customerNationalCode: "" });
  };
  return (
    <div>
      <div className="row" style={{ paddingBottom: " 5px " }}>
        <div
          className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
          style={{ marginTop: "1vh" }}
        >
          <MaterialTextFieldComponent
            helperText={""}
            placeHolder={"کد ملی"}
            label={"کد ملی "}
            required={false}
            value={formData?.customerNationalCode}
            onChange={changeValueCustomerNationalCode}
            name="customerNationalCode"
            id="customerNationalCode"
          />
        </div>
        <div
          className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 butFilter"
          style={{ marginTop: "1vh" }}
        >
          <Button
            fullWidth
            variant="contained"
            type="submit"
            className="btnForm SuccessDefault"
            onClick={handleFormSubmit}
          >
            فیلتر
          </Button>
        </div>
      </div>
      {formData?.customerNationalCode && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "10px",
          }}
          className="row tableCMP"
        >
          <Button
            onClick={deleteChip}
            style={{
              justifyContent: "right",
              minWidth: "25px",
              marginRight: "-1vh",
              marginTop: "1vh",
            }}
          >
            <img
              style={{ height: "24px", width: "24px" }}
              src="images/RemoveAllFilters.svg"
              alt=""
            />
          </Button>
          <ChipCmp
            item={formData?.customerNationalCode}
            enamValue={formData?.customerNationalCode}
            index={formData?.customerNationalCode?.length}
            setChildValue={setChildcustomerNationalCode}
          />
        </div>
      )}
      <div className="cardTableBorder">
        <TableContainer
          style={{ background: "#fff", maxHeight: "55vh" }}
          className="boxScroll"
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            style={{ borderCollapse: "collapse" }}
          >
            <TableHead className="rowTHead" style={{ paddingBottom: "10px" }}>
              <TableRow
                classes={{ root: classes.select }}
                className={`${classes} borderRight borderLeft`}
                selected={selectedRow === 0}
              >
                <TableCell
                  className="rowTHead colorTitle textFont12 fontWeight"
                  align="right"
                ></TableCell>
                <TableCell
                  className="rowTHead colorTitle textFont12 fontWeight"
                  align="right"
                  style={{ width: "10vh", minWidth: "10vh" }}
                >
                  #
                </TableCell>
                {columns.map((column) => (
                  <TableCell
                    className="rowTHead colorTitle textFont12 fontWeight noWrap"
                    key={column.id}
                    align="right"
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <div style={{ width: "100%", height: "10px" }}></div>
            <TableBody>
              {saleItems
                ? saleItems.map((row, rowIndex) => {
                    return (
                      <TableRow
                        classes={{ root: classes.select }}
                        className={`${
                          rowIndex % 2 === 0 ? "rowTBodyE  " : "rowTBodyO "
                        } ${classes} borderRight borderLeft cursorPointer noWrap`}
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row.id}
                        selected={selectedRow === rowIndex}
                        onClick={() => {
                          handleClickRow(row);
                        }}
                      >
                        <TableCell className="textFont12" align="right">
                          {row.isInUserCartable ? (
                            <EmojiObjectsIcon
                              style={{ color: "#fbc02d", fontSize: "25px" }}
                            />
                          ) : (
                            <EmojiObjectsOutlinedIcon
                              style={{ color: "#C1C7CB", fontSize: "25px" }}
                            />
                          )}
                        </TableCell>
                        <TableCell
                          className="textFont12"
                          style={{ width: "10vh", minWidth: "10vh" }}
                        >
                          {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                            (currentPaginationInfo.pageSize! ?? 0) +
                            rowIndex +
                            1}
                        </TableCell>
                        {columns.map((column) => {
                          const value =
                            row[column.id as keyof GetSaleItemsResponse];
                          return (
                            <>
                              {
                                <TableCell
                                  className="textFont12"
                                  key={column.id}
                                  align="right"
                                >
                                  {column.id === "storeTitle"
                                    ? `${value} / ${row.branchTitle}`
                                    : column.format && column.hasFormat
                                    ? column.format(value)
                                    : value?.toString()}
                                </TableCell>
                              }
                            </>
                          );
                        })}
                      </TableRow>
                    );
                  })
                : null}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div>
        <div className="row"></div>
        <Grid container xs={12}>
          <Grid item xs={4}>
            <span
              style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
            >
              تعداد کل :
              <span style={{ color: "#01AF43" }}>{paginationInfo?.total}</span>{" "}
              مورد
            </span>
          </Grid>
          <Grid item xs={4}>
            <Pagination
              renderItem={(item) => (
                <PaginationItem
                  components={{
                    previous: previusIcon,
                    next: nextIcon,
                  }}
                  {...item}
                />
              )}
              // color="primary"
              sx={{
                display: "flex",
                justifyContent: "center !important",
                direction: "ltr",
                margin: "5px",
                button: {
                  color: "#25D1C9",
                  fontSize: "14px !important",
                  fontFamily: "iranSans",
                },
                //  button.sele
              }}
              count={
                paginationInfo
                  ? Math.ceil(paginationInfo?.total / paginationInfo?.pageSize)
                  : 0
              }
              onChange={handleChangePagination}
              page={currentPaginationInfo?.pageNumber}
            />
          </Grid>
          <Grid item xs={4}></Grid>
        </Grid>
      </div>
    </div>
  );
};

export default SaleSettlementList;
